module.exports = __webpack_public_path__ + "assets/adpoly-it-printers-bulk-upload-template.3386d8b1.xlsx";